import { IFetchProductVariantGridSchema } from '@bitmap/contracts';
import { Tooltip } from '../Tooltip';
import { Box } from '@/src/packages/components/ui/Box';
import clsx from 'clsx';
import { getColorVariantHex } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductVariantSelector';

export const ProductCardSwatches = ({
  productVariant,
}: {
  productVariant: IFetchProductVariantGridSchema;
}) => {
  return (
    <Box className="inline-flex gap-2">
      {productVariant.product.variants.map((variant) => {
        const isActive =
          productVariant.productOptionValue.id === variant.productOptionValueId;

        return (
          <Tooltip
            content={variant.productOptionValue.productOption.name}
            key={variant.id}
          >
            <Box
              className={clsx('border p-0.5 rounded-full', {
                'border-gray-400': isActive,
                'border-transparent': !isActive,
              })}
            >
              <Box
                className="w-2.5 h-2.5 rounded-full"
                style={{
                  backgroundColor: getColorVariantHex(
                    variant.productOptionValue.name
                  ),
                }}
              />
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};
